module.exports = __webpack_public_path__ + "static/media/logofema.d7b512c2.svg";